import { mapGetters } from 'vuex';
import { fastContract, getSkill } from '@/api/modules/product.js';
export default {
  name: 'SkillPlaza',
  data() {
    return {
      loading: false,
      // 加载状态防闪烁
      activeTabIndex: 0,
      // 当前选中的 Tab 索引

      // 🌟 新增：弹窗控制变量
      modalVisible: false,
      // 控制弹窗显示隐藏
      currentCard: {},
      // 当前点击的卡片数据对象

      advantagesData: [{
        title: '直连同花顺<br/>核心<span class="highlight">数据接口</span>',
        desc: '深度接入权威金融数据资源，覆盖行情、财务、宏观及多资产数据，并融合丰富的金融信息数据，确保信息全面、实时、可靠。',
        img: require('@/assets/images/technology/SkillMarket/sjjk.png')
      }, {
        title: '经验沉淀为<br/>专属 <span class="highlight">Skill</span>',
        desc: '将投研方法、决策逻辑与实战经验模块化封装，形成可调用、可复用、可迭代的智能能力。',
        img: require('@/assets/images/technology/SkillMarket/skill.png')
      }, {
        title: '全场景<br/>投资<span class="highlight">能力覆盖</span>',
        desc: '从数据获取、分析研判到标的筛选与策略辅助，贯穿投研全流程，满足多角色、多场景需求。',
        img: require('@/assets/images/technology/SkillMarket/nlfg.png')
      }, {
        title: '高扩展的AI<br/><span class="highlight">能力架构</span> (ONE矩阵)',
        desc: '支持灵活组合与持续进化，快速接入新策略、新模型与新数据源，构建长期可成长的金融智能体系。',
        img: require('@/assets/images/technology/SkillMarket/nljz.png')
      }],
      tabsData: [{
        name: '金融数据类',
        desc: '整合全品类金融数据资源，一站式获取股票、基金、指数、宏观经济等多维数据，支持快速调用与深度分析，为投资决策提供坚实数据基础'
      }, {
        name: '金融分析类',
        desc: '将专业分析方法标准化封装，涵盖个股分析、市场解读、行业研究等能力，让复杂分析流程简单化，让专业能力普惠化'
      }],
      bannerImg: require('@/assets/images/technology/SkillMarket/banner.png'),
      pagedCards: [],
      // 后端返回的当前页卡片列表
      total: 0,
      // 总条数
      currentPage: 1,
      // 当前页码
      pageSize: 9 // 每页条数
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.total / this.pageSize);
    },
    startIndex() {
      if (this.total === 0) return 0;
      return (this.currentPage - 1) * this.pageSize + 1;
    },
    endIndex() {
      return Math.min(this.currentPage * this.pageSize, this.total);
    },
    ...mapGetters(['list', 'haslogin'])
  },
  created() {
    this.getData();
  },
  methods: {
    // 🌟 新增：点击卡片打开弹窗
    handleCardClick(card) {
      this.currentCard = card;
      this.modalVisible = true;
    },
    // 🌟 新增：弹窗内部的“立即试用”点击响应
    handleModalTrial() {
      this.modalVisible = false; // 先关闭弹窗
      this.handleTrial(); // 调用通用的立即试用逻辑
    },
    // 立即试用/预约按钮通用业务逻辑
    handleTrial() {
      const h = this.$createElement;
      if (this.haslogin) {
        fastContract({
          source: '官网',
          product_name: this.$route.meta.title
        }).then(res => {
          if (res.code === 1) {
            this.$success({
              title: '预约成功',
              content: h("div", [h("p", ["\u60A8\u7684\u7533\u8BF7\u5DF2\u63D0\u4EA4\uFF0C\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u548C\u60A8\u8054\u7CFB\uFF01"]), h("p", ["\u5982\u6709\u4EFB\u4F55\u95EE\u9898\uFF0C\u8BF7\u8054\u7CFB\u5BF9\u63A5\u7684\u540C\u82B1\u987A\u9500\u552E\u540C\u4E8B\u6216\u81F4\u75350571-88911818"])])
            });
          }
        });
      } else {
        this.$confirm({
          title: '您还没有登录，请点击前往登录',
          onOk: () => {
            this.$router.replace({
              path: '/login'
            });
          },
          centered: true
        });
      }
    },
    // 获取接口数据与服务端分页
    getData() {
      this.loading = true;
      let params = {};
      if (this.activeTabIndex === 0) {
        params = {
          current: this.currentPage,
          size: this.pageSize,
          tenant: 14,
          platform: 'iwencai',
          classify: 'OFFICIAL'
        };
      } else if (this.activeTabIndex === 1) {
        params = {
          current: this.currentPage,
          size: this.pageSize,
          tenant: 36,
          platform: 'cxyy',
          classify: '金融分析'
        };
      }
      getSkill(params).then(res => {
        const data = res.data || res;
        if (data && data.records) {
          this.pagedCards = data.records.map(item => ({
            name: item.cn_name || item.name,
            author: `@${item.username}`,
            desc: item.description || '暂无描述'
          }));
          this.total = data.total || 0;
        } else {
          this.pagedCards = [];
          this.total = 0;
        }
      }).catch(err => {
        console.error('拉取技能列表失败:', err);
        this.pagedCards = [];
        this.total = 0;
      }).finally(() => {
        this.loading = false;
      });
    },
    // Tab 点击切换
    handleTabClick(index) {
      if (this.activeTabIndex === index) return;
      this.activeTabIndex = index;
      this.currentPage = 1;
      this.getData();
    },
    // 分页切页器
    handlePageChange(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
      this.getData();
    },
    // 解析卡片首字母生成彩色头像配置
    getAvatarProps(name) {
      if (!name) return {
        char: '',
        style: {}
      };
      const char = name.charAt(0).toUpperCase();
      const colors = [{
        bg: '#ffebee',
        color: '#f44336'
      }, {
        bg: '#e8f5e9',
        color: '#4caf50'
      }, {
        bg: '#e3f2fd',
        color: '#2196f3'
      }, {
        bg: '#fff3e0',
        color: '#ff9800'
      }, {
        bg: '#f3e5f5',
        color: '#9c27b0'
      }, {
        bg: '#e0f2f1',
        color: '#009688'
      }];
      let hash = 0;
      for (let i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
      }
      const index = Math.abs(hash) % colors.length;
      return {
        char,
        style: {
          backgroundColor: colors[index].bg,
          color: colors[index].color
        }
      };
    }
  }
};